import { fetchAuthSession } from "aws-amplify/auth";

const awsgateway = {
  API: {
    endpoints: [
      {
        name: "UserManagementApi",
        endpoint:
            "https://user-management-qi.gateway.hubwise.co.uk/admin/v1/user-management",
        custom_header: async () => {
          return {
            Authorization: (await fetchAuthSession()).tokens?.idToken
          };
        },
      },
      {
        name: "ChangelogAPi",
        endpoint : "https://api-changelog.hubwise.co.uk/changelog?stage=qi",
        custom_header: async () => {
          return {
            Authorization: (await fetchAuthSession()).tokens?.idToken,
            Environment: "staging",
          };
        },

      },
      {
        name: "PortalApi",
        endpoint: "https://adviser-qi.gateway.hubwise.co.uk/admin/api",
        custom_header: async () => {
          return {
            Authorization: (await fetchAuthSession()).tokens?.idToken
          };
        }
      }
    ],
  },
};

export default awsgateway;
